import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import styles from "./DateTime.css";
import errorStyles from "validation.css";

export default class DateTime extends React.Component {
  render() {
    const { placeholder, error, hideError, ...rest } = this.props;

    const inputProps = {
      className: classNames(styles.input, {
        [errorStyles.hasError]: !!error,
      }),
      placeholder: placeholder,
      onKeyDown: e => {
        if (e.key !== "Tab") {
          e.preventDefault();
        }
      },
    };

    const errorDisplay =
      hideError || !error ? null : (
        <label htmlFor="date" className={errorStyles.errorText}>
          {error.message || error}
        </label>
      );

    return (
      <div>
        <Datetime closeOnSelect={true} inputProps={inputProps} {...rest} />
        {errorDisplay}
      </div>
    );
  }
}

DateTime.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  timeFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    .isRequired,
  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    .isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.instanceOf(Error),
  ]),
  hideError: PropTypes.bool,
};
